import EditIcon from '../../components/Icons/Edit';
import { suffixOptionsValues } from '../constants';
import { formatMoney } from './numeralHelpers';

export const formatName = (FirstName, LastName, MiddleName, Suffix) => {
  let name = `${FirstName} ${LastName}`;
  if (MiddleName) {
    name = `${FirstName} ${MiddleName} ${LastName}`;
  }

  if (Suffix) {
    name = `${name} ${suffixOptionsValues[Suffix]}`;
  }

  return name;
};

export const formatBirthday = (month, day, year) => {
  const formatNumber = (value) => String(value).padStart(2, '0');

  return `${formatNumber(month)}/${formatNumber(day)}/${year}`;
};

export const buildProductProps = (
  product,
  rootUrl,
  imageCode,
  showIcon = true,
) => ({
  title: `${product.ProductCaption} (${formatMoney(product.Amount)} /month)`,
  subtitle: product.Location,
  paragraphTitle: true,
  imageUrl: imageCode
    .replace('{product_code}', product.ProductCode)
    .replace('{base_url}', rootUrl),
  imageAlt: product.ProductCode,
  Icon: EditIcon,
  showIcon,
});
